import AccountCardCheckoutSuccessAlert from './AccountCardCheckoutSuccessAlert';

export default AccountCardCheckoutSuccessAlert;
